/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reports_Cases_By_Client_TitleInputs */

const en_reports_cases_by_client_title = /** @type {(inputs: Reports_Cases_By_Client_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cases by client`)
};

const pt_br2_reports_cases_by_client_title = /** @type {(inputs: Reports_Cases_By_Client_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Casos por cliente`)
};

/**
* | output |
* | --- |
* | "Cases by client" |
*
* @param {Reports_Cases_By_Client_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const reports_cases_by_client_title = /** @type {((inputs?: Reports_Cases_By_Client_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reports_Cases_By_Client_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reports_cases_by_client_title(inputs)
	return pt_br2_reports_cases_by_client_title(inputs)
});